import { z } from "zod/v4";

export const RequestPluginPerformanceCallbackRequestQueryParamSchema = z.object(
  { id: z.string() }
);

export type RequestPluginPerformanceCallbackRequestQueryParamType = z.infer<
  typeof RequestPluginPerformanceCallbackRequestQueryParamSchema
>;

export const RequestPluginPerformanceCallbackResponseBodySchema = z.string();

export type RequestPluginPerformanceCallbackResponseBodyType = z.infer<
  typeof RequestPluginPerformanceCallbackResponseBodySchema
>;
